import {EventEmitter, Injectable} from '@angular/core';
import {HelpersService} from '../../../core/helpers/helpers.service';
import {ActivatedRoute} from '@angular/router';

@Injectable()
export class PagingController {
  protected _current = 0;
  protected _total = 0;
  protected _pageSize = 5;

  public get current() {
    return this._current;
  }

  public get total() {
    return this._total;
  }

  public get pageSize() {
    return this._pageSize;
  }


  public pageChanged: EventEmitter<PagingController> = new EventEmitter();

  constructor(protected helpers: HelpersService,
              protected route: ActivatedRoute) {
    route.params.subscribe(val => {
      this.parseParams();
    });
    route.queryParams.subscribe(val => {
      this.parseParams();
    });
  }

  private parseParams() {
    this._current = Math.max(0, parseInt(this.route.snapshot.queryParamMap.get('page') || this._current.toString(), 10));

    // this.helpers.logger.info('PagingController: Params Parsed', this);

    this.pageChanged.emit(this);
  }

  public get hasPrev(): boolean {
    return this.current > 0;
  }

  public get prev(): number {
    return Math.max(0, this.current - 1);
  }

  public get hasNext(): boolean {
    return this.current < this.total - 1;
  }

  public get next(): number {
    return Math.min(this.current + 1, this.total - 1);
  }

  public get pages(): Array<number> {
    return Array.apply(null, {length: this.total}).map(Function.call, Number);
  }

  public init(current: number = 0, total: number = 0, pageSize: number = 5) {
    this._current = current;
    this._total = total;
    this._pageSize = pageSize;
    this.parseParams();
  }

  public update(length: number) {
    this._total = Math.ceil(length / this.pageSize);
    this._current = Math.max(0, Math.min(this.current, this.total - 1));

    // this.helpers.logger.info('PagingController: Updated', this);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/shared/commons/paging-controller/paging-controller.ts